import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { closeModal, openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector(
    '.header__background',
  );
  if (backgroundContainer) {
    const resizeCallback = throttle(
      () =>
        document.documentElement.style.setProperty(
          '--header-height',
          `${backgroundContainer.clientHeight}px`,
        ),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);

    const announcementBarHeight =
      document.documentElement.style.getPropertyValue(
        '--announcement-bar-height',
      );
    const scrollOffset = announcementBarHeight
      ? parseInt(announcementBarHeight.replace('px', ''))
      : 0;

    let lastScrollTop = window.scrollY;
    if (
      typeof backgroundContainer.dataset.transparent !== 'undefined' ||
      typeof backgroundContainer.dataset.expanded !== 'undefined'
    ) {
      const scrollCallback = throttle(() => {
        if (sectionContainer.querySelector('.mobile-menu__container.open'))
          return;
        if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
          backgroundContainer.dataset.transparent =
            window.scrollY <= scrollOffset;
        } else {
          console.log('header retractable');

          let currentScroll = window.scrollY;

          if (currentScroll !== 0) {
            backgroundContainer.dataset.expanded =
              currentScroll < lastScrollTop;
            if (currentScroll < lastScrollTop) {
              console.log("Scrolling verso l'alto");
            } else {
              console.log('Scrolling verso il basso');
              console.log('currentScroll', currentScroll);
              console.log('lastScrollTop', lastScrollTop);
            }
          } else {
            backgroundContainer.dataset.expanded = true;
          }

          lastScrollTop = currentScroll;
        }
      }, 200);
      scrollCallback();
      window.addEventListener('scroll', scrollCallback);
    }
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector(
    '.header__action-cart-counter',
  );
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) cartCounter.innerText = cart.item_count;
    });
  }

  const searchWrapper = sectionContainer.querySelector('.header__search');
  const searchIcon = sectionContainer.querySelector('.header__action--search');
  if (searchWrapper && searchIcon) {
    const mainInput = searchWrapper.querySelector('input[name="q"]');
    const closeWrapper = searchWrapper.querySelector('.header__search-close');
    if (mainInput && closeWrapper) {
      const closeSearch = () => {
        backgroundContainer.dataset.searchOpen = 'false';
        mainInput.value = '';
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      closeWrapper.addEventListener('click', closeSearch);
      searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        if (backgroundContainer.dataset.searchOpen == 'true') {
          closeSearch();
        } else {
          if (window.innerWidth < parseInt(breakpoints.lg)) {
            const openMobileMenu = sectionContainer.querySelector(
              '.mobile-menu__container',
            );
            if (openMobileMenu) {
              const modal = openMobileMenu.querySelector('.modal');
              if (!openMobileMenu.classList.contains('open')) {
                const announcementHeight = parseInt(
                  getComputedStyle(document.documentElement).getPropertyValue(
                    '--announcement-bar-height',
                  ),
                );
                if (window.scrollY < announcementHeight)
                  window.scrollTo({
                    top: announcementHeight,
                    behavior: 'smooth',
                  });

                openMobileMenu.classList.add('open');
                openModal(modal);
              }

              openMobileMenu
                .querySelectorAll('.mobile-menu__second-level')
                .forEach((secondLevel) => {
                  if (secondLevel.classList.contains('open'))
                    secondLevel.classList.remove('open');
                });

              const mobileInput =
                openMobileMenu.querySelector('input[name="q"]');
              mobileInput.focus();
            }
          } else {
            document
              .querySelectorAll('.desktop-menu__first-level-link')
              .forEach((firstLevel) => firstLevel.classList.remove('open'));

            backgroundContainer.dataset.searchOpen = 'true';
            mainInput.focus();
          }
        }
      });
    }
  }
};

execOnLoad(window.dAgency.initHeader, '.header__section');
